// Translations
import invitationDialog from '../components/invitation-dialog/translations/ar'
import removalDialog from '../components/removal-dialog/translations/ar'

// Translation: Account > Members > Members list (Arabic)
export default Object.freeze({
	components: { invitationDialog, removalDialog },
	controls: {
		invite: ''
	},
	table: {
		fields: {
			actions: '',
			email: '',
			name: '',
			role: ''
		}
	}
})
